import React from 'react';

// Pastel Glyph Icons Component Library
// Inspired by Icons8 Pastel Glyph style with soft colors and rounded shapes

export const SearchIcon = ({ size = 24, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <circle
      cx="11"
      cy="11"
      r="8"
      fill="url(#searchGradient)"
      stroke="#a8dadc"
      strokeWidth="2"
    />
    <path
      d="m21 21-4.35-4.35"
      stroke="#457b9d"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <defs>
      <linearGradient id="searchGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#f1faee" />
        <stop offset="100%" stopColor="#a8dadc" />
      </linearGradient>
    </defs>
  </svg>
);

export const DownloadIcon = ({ size = 24, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      d="M12 3v13m0 0l-4-4m4 4l4-4"
      stroke="#e63946"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="4"
      y="18"
      width="16"
      height="3"
      rx="1.5"
      fill="url(#downloadGradient)"
      stroke="#e63946"
      strokeWidth="1.5"
    />
    <defs>
      <linearGradient id="downloadGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#ffb3ba" />
        <stop offset="100%" stopColor="#ffcccb" />
      </linearGradient>
    </defs>
  </svg>
);

export const RefreshIcon = ({ size = 24, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"
      stroke="#457b9d"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 3v5h-5"
      stroke="#457b9d"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"
      stroke="#457b9d"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 21v-5h5"
      stroke="#457b9d"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FilterIcon = ({ size = 24, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <polygon
      points="22,3 2,3 10,12.46 10,19 14,21 14,12.46"
      fill="url(#filterGradient)"
      stroke="#264653"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient id="filterGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#caffbf" />
        <stop offset="100%" stopColor="#9bf6ff" />
      </linearGradient>
    </defs>
  </svg>
);

export const StatsIcon = ({ size = 24, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <rect
      x="3"
      y="11"
      width="4"
      height="10"
      rx="2"
      fill="url(#statsGradient1)"
      stroke="#e9c46a"
      strokeWidth="1.5"
    />
    <rect
      x="10"
      y="7"
      width="4"
      height="14"
      rx="2"
      fill="url(#statsGradient2)"
      stroke="#f4a261"
      strokeWidth="1.5"
    />
    <rect
      x="17"
      y="3"
      width="4"
      height="18"
      rx="2"
      fill="url(#statsGradient3)"
      stroke="#e76f51"
      strokeWidth="1.5"
    />
    <defs>
      <linearGradient id="statsGradient1" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#ffd166" />
        <stop offset="100%" stopColor="#f9c74f" />
      </linearGradient>
      <linearGradient id="statsGradient2" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#f9844a" />
        <stop offset="100%" stopColor="#f8961e" />
      </linearGradient>
      <linearGradient id="statsGradient3" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#f3722c" />
        <stop offset="100%" stopColor="#f94144" />
      </linearGradient>
    </defs>
  </svg>
);

export const BackIcon = ({ size = 24, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      d="M19 12H5m0 0l7 7m-7-7l7-7"
      stroke="#6c5ce7"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="12"
      cy="12"
      r="11"
      fill="url(#backGradient)"
      stroke="#a29bfe"
      strokeWidth="1"
      opacity="0.2"
    />
    <defs>
      <linearGradient id="backGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e17055" stopOpacity="0.1" />
        <stop offset="100%" stopColor="#6c5ce7" stopOpacity="0.1" />
      </linearGradient>
    </defs>
  </svg>
);

export const LogoutIcon = ({ size = 24, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
      stroke="#e17055"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polyline
      points="16,17 21,12 16,7"
      stroke="#e17055"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="21"
      y1="12"
      x2="9"
      y2="12"
      stroke="#e17055"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <rect
      x="2"
      y="4"
      width="8"
      height="16"
      rx="2"
      fill="url(#logoutGradient)"
      opacity="0.3"
    />
    <defs>
      <linearGradient id="logoutGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#fd79a8" />
        <stop offset="100%" stopColor="#e84393" />
      </linearGradient>
    </defs>
  </svg>
);

export const UserIcon = ({ size = 24, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
      stroke="#00b894"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="12"
      cy="7"
      r="4"
      fill="url(#userGradient)"
      stroke="#00cec9"
      strokeWidth="2"
    />
    <defs>
      <linearGradient id="userGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#55efc4" />
        <stop offset="100%" stopColor="#81ecec" />
      </linearGradient>
    </defs>
  </svg>
);

export const SettingsIcon = ({ size = 24, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <circle
      cx="12"
      cy="12"
      r="3"
      fill="url(#settingsGradient)"
      stroke="#636e72"
      strokeWidth="1.5"
    />
    <path
      d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
      stroke="#636e72"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient id="settingsGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#ddd" />
        <stop offset="100%" stopColor="#b2bec3" />
      </linearGradient>
    </defs>
  </svg>
);

export const LockIcon = ({ size = 24, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <rect
      x="3"
      y="11"
      width="18"
      height="11"
      rx="2"
      ry="2"
      fill="url(#lockGradient)"
      stroke="#2d3436"
      strokeWidth="1.5"
    />
    <circle
      cx="12"
      cy="16"
      r="1"
      fill="#636e72"
    />
    <path
      d="M7 11V7a5 5 0 0 1 10 0v4"
      stroke="#2d3436"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient id="lockGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#fd79a8" />
        <stop offset="100%" stopColor="#e84393" />
      </linearGradient>
    </defs>
  </svg>
);

export const UnlockIcon = ({ size = 24, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <rect
      x="3"
      y="11"
      width="18"
      height="11"
      rx="2"
      ry="2"
      fill="url(#unlockGradient)"
      stroke="#00b894"
      strokeWidth="1.5"
    />
    <circle
      cx="12"
      cy="16"
      r="1"
      fill="#00cec9"
    />
    <path
      d="M7 11V7a5 5 0 0 1 9.9-1"
      stroke="#00b894"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient id="unlockGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#55efc4" />
        <stop offset="100%" stopColor="#81ecec" />
      </linearGradient>
    </defs>
  </svg>
);

export const AdminIcon = ({ size = 24, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"
      fill="url(#adminGradient)"
      stroke="#6c5ce7"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M9 12l2 2 4-4"
      stroke="#ffffff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient id="adminGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#a29bfe" />
        <stop offset="100%" stopColor="#6c5ce7" />
      </linearGradient>
    </defs>
  </svg>
);

export const TrashIcon = ({ size = 24, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <polyline
      points="3,6 5,6 21,6"
      stroke="#e17055"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
      fill="url(#trashGradient)"
      stroke="#e17055"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <line
      x1="10"
      y1="11"
      x2="10"
      y2="17"
      stroke="#ffffff"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <line
      x1="14"
      y1="11"
      x2="14"
      y2="17"
      stroke="#ffffff"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <defs>
      <linearGradient id="trashGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#fab1a0" />
        <stop offset="100%" stopColor="#e17055" />
      </linearGradient>
    </defs>
  </svg>
);

export const KeyIcon = ({ size = 24, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <circle
      cx="7.5"
      cy="15.5"
      r="5.5"
      fill="url(#keyGradient)"
      stroke="#fdcb6e"
      strokeWidth="1.5"
    />
    <path
      d="M21 2l-9.6 9.6"
      stroke="#e17055"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5 7.5l3 3L22 7l-3-3"
      stroke="#e17055"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient id="keyGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#ffeaa7" />
        <stop offset="100%" stopColor="#fdcb6e" />
      </linearGradient>
    </defs>
  </svg>
);

// Export all icons as a single object for easier importing
export const PastelGlyphIcons = {
  Search: SearchIcon,
  Download: DownloadIcon,
  Refresh: RefreshIcon,
  Filter: FilterIcon,
  Stats: StatsIcon,
  Back: BackIcon,
  Logout: LogoutIcon,
  User: UserIcon,
  Settings: SettingsIcon,
  Lock: LockIcon,
  Unlock: UnlockIcon,
  Admin: AdminIcon,
  Trash: TrashIcon,
  Key: KeyIcon,
};

export default PastelGlyphIcons;